import styled from 'styled-components';

export const StyledMachineDetailsRobotOverview = styled.div`
  min-height: inherit;
`;
